import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`The Images Object`}</h2>
    <p>{`The Images Object found in the GIF Object contains a series of Rendition Objects. These Rendition Objects includes the URLs and sizes for the many different renditions we offer for each GIF. For more information and best practices on selecting the best image format for your needs, please see our `}<a href="/docs/optional-settings#rendition-guide">{`Rendition Guide`}</a>{`. (Please note that some GIFs don’t have every property available.)`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Object`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`fixed_height:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on versions of this GIF with a fixed height of 200 pixels. Good for mobile use.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The publicly-accessible direct URL for this GIF for this size of the GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/200.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size of this GIF in bytes.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"32381"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`mp4:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The URL for this GIF in .MP4 format.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/200.mp4"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`mp4_size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{` The size in bytes of the .MP4 file corresponding to this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"25123"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`webp:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The URL for this GIF in .webp format.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/200.webp"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`webp_size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size in bytes of the .webp file corresponding to this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"12321"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`fixed_height_still:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on a static image of this GIF with a fixed height of 200 pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The publicly-accessible direct URL for this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/200_s.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`fixed_height_downsampled:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on versions of this GIF with a fixed height of 200 pixels and the number of frames reduced to 6.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The publicly-accessible direct URL for this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/200_d.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size of this GIF in bytes.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"32381"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`webp:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The URL for this GIF in .webp format.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/200_d.webp"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`webp_size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size in bytes of the .webp file corresponding to this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"12321"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`fixed_width:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on versions of this GIF with a fixed width of 200 pixels. Good for mobile use.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The publicly-accessible direct URL for this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/200w.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size of this GIF in bytes.`}<br />{`"32381"`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"32381"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`mp4:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The URL for this GIF in .MP4 format.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/200w.mp4"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`mp4_size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size in bytes of the .MP4 file corresponding to this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"25123"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`webp:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The URL for this GIF in .webp format.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/200w.webp"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`webp_size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size in bytes of the .webp file corresponding to this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"12321"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`fixed_width_still:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on a static image of this GIF with a fixed width of 200 pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The publicly-accessible direct URL for this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/200w_s.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`fixed_width_downsampled:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on versions of this GIF with a fixed width of 200 pixels and the number of frames reduced to 6.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The publicly-accessible direct URL for this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/200w_d.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size of this GIF in bytes.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"32381"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`webp:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The URL for this GIF in .webp format.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/200w_d.webp"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`webp_size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size in bytes of the .webp file corresponding to this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"12321"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`fixed_height_small:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on versions of this GIF with a fixed height of 100 pixels. Good for mobile keyboards.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The publicly-accessible direct URL for this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/100.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"100"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size of this GIF in bytes.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"32381"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`mp4:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The URL for this GIF in .MP4 format.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/100.mp4"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`mp4_size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size in bytes of the .MP4 file corresponding to this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"25123"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`webp:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The URL for this GIF in .webp format.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/100.webp"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`webp_size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size in bytes of the .webp file corresponding to this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"12321"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`fixed_height_small_still:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on a static image of this GIF with a fixed height of 100 pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The publicly-accessible direct URL for this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/100_s.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"100"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`fixed_width_small:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on versions of this GIF with a fixed width of 100 pixels. Good for mobile keyboards.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The publicly-accessible direct URL for this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/100w.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"100"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size of this GIF in bytes.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"32381"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`mp4:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The URL for this GIF in .MP4 format.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/100w.mp4"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`mp4_size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size in bytes of the .MP4 file corresponding to this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"25123"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`webp:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The URL for this GIF in .webp format.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/100w.webp"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`webp_size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size in bytes of the .webp file corresponding to this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"12321"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`fixed_width_small_still:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on a static image of this GIF with a fixed width of 100 pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The publicly-accessible direct URL for this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/100w_s.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"100"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`downsized:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on a version of this GIF downsized to be under 2mb.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The publicly-accessible direct URL for this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/giphy-downsized.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size of this GIF in bytes.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"12381"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`downsized_still:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on a static preview image of the downsized version of this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The publicly-accessible direct URL for this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/giphy-downsized_s.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`downsized_large:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on a version of this GIF downsized to be under 8mb.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The publicly-accessible direct URL for this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/giphy-downsized-large.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size of this GIF in bytes.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"12381"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`downsized_medium:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on a version of this GIF downsized to be under 5mb.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The publicly-accessible direct URL for this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/giphy-downsized-medium.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size of this GIF in bytes.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"12381"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`downsized_small:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on a version of this GIF downsized to be under 200kb.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`mp4:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The publicly-accessible direct URL for this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/downsized_small.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`mp4_size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size of this GIF in bytes.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"12381"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`original:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on the original version of this GIF. Good for desktop use.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size of this GIF in bytes.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"12381"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`frames:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The number of frames in this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"15"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`mp4:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The URL for this GIF in .MP4 format.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/giphy.mp4"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`mp4_size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size in bytes of the .MP4 file corresponding to this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"25123"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`webp:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The URL for this GIF in .webp format.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/giphy.webp"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`webp_size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size in bytes of the .webp file corresponding to this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"12321"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`original_still:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on a static preview image of the original GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The publicly-accessible direct URL for this GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/giphy_s.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`looping:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on the 15 second version of the GIF looping.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`mp4:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The URL for this GIF in .MP4 format.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/looping.mp4"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`preview:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on a version of this GIF in .MP4 format limited to 50kb that displays the first 1-2 seconds of the GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`mp4:`}</strong>{` `}<em parentName="td">{`string`}</em><br />{`he URL for this GIF in .MP4 format.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/giphy-preview.mp4"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`mp4_size:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The size of this file in bytes.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"20241"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this file in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this file in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`preview_gif:`}</strong>{` `}<em parentName="td">{`object`}</em>{` `}<br />{`Data on a version of this GIF limited to 50kb that displays the first 1-2 seconds of the GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The URL for this preview GIF.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"https://media1.giphy.com/media/cZ7rmKfFYOvYI/giphy-preview.gif"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`width:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The width of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"320"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`height:`}</strong>{` `}<em parentName="td">{`string`}</em>{` `}<br />{`The height of this GIF in pixels.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"200"`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      